import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/modal';

import {WidgetLoader, asClassWidget} from './core/widgetLoader';
import NavbarWidget from './widgets/navbarWidget';
import SwiperWidget from './widgets/swiperWidget';
import DatetimePickerWidget from './widgets/datetimePickerWidget';

const registry = [
    asClassWidget('[data-app-navbar]', NavbarWidget, {stickyClass: 'is-sticky'}),
	asClassWidget('[data-app-swiper]', SwiperWidget),
	asClassWidget('[data-app-datetimepicker]', DatetimePickerWidget)
];

const loader = new WidgetLoader(registry);

// Init on DOM ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        loader.init();
    });
} else {
    loader.init();
}

document.addEventListener('DOMContentLoaded', () => {
	const forms = document.querySelectorAll('.needs-validation');
	console.log("Im loaded");
	console.log(forms);

	// Loop over them and prevent submission
	Array.from(forms).forEach(form => {
		form.addEventListener('submit', event => {
			console.log("Submit");

			if (!form.checkValidity()) {
				event.preventDefault()
				event.stopPropagation()
			}

			form.classList.add('was-validated')
		}, false)
	});
});